import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { perfilService } from '../services/perfilService';

export function usePerfil() {
  return useQuery({ queryKey: ['perfil'], queryFn: perfilService.get });
}

export function useUpdatePerfil() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: perfilService.update,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['perfil'] }),
  });
}

export function useUpdateAreasPerfil() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: perfilService.updateAreas,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['perfil'] }),
  });
}
